import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  fulfilledHandler,
  loadingHandler,
  rejectedHandler,
} from "../initialState";
import api from "../../api";

export const GetConfigSemester = createAsyncThunk(
  "configSemester/GetConfigSemester",
  async (token, thunkAPI) => {
    let response;
    try {
      response = await axios.get(`${api}config/semester`, {
        headers: {
          Authorization: token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const configSemesterSlice = createSlice({
  name: "configSemester",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    // get all configSemester
    builder.addCase(GetConfigSemester.pending, loadingHandler);
    builder.addCase(GetConfigSemester.fulfilled, fulfilledHandler);
    builder.addCase(GetConfigSemester.rejected, rejectedHandler);
  },
});

export const { reset } = configSemesterSlice.actions;
export default configSemesterSlice.reducer;
